import React, { ChangeEvent, useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@state/actions';
import selectors from '@state/selectors';
import {IProps} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import ComboBox from '@components/ComboBox';
import Input from '@components/Input';
import Button from '@components/Button';
import Loading from '@components/Loading';

const Folders:React.FC<IProps> = (props) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState("");
  const [tipLabel, setTipLabel] = useState("");
  const [isChecking, setIsChecking] = useState(false);
  const [addFolder, setAddFolder] = useState(true);
  const [checked, setChecked]=useState(false);

  const [foldersList, setFoldersList]=useState([] as any);
  const [folderSelected, setFolderSelected] = useState("");

  const [showLoading, setShowLoading]=useState(true);

  const folders = useSelector(selectors.folders.getFolders);

  const fetchFolders = () => {
    setShowLoading(true);
    let query = `?filter=c.createdBy.email='${props.userData.email}'`;
    return new Promise((resolve, reject) => {
      dispatch(actions.folders.fetchFolders(query,(result, error) => {
        if (error) reject(error)
        else resolve(result)
        setShowLoading(false);
      }))
    });
  }

  useEffect(() => {  
    const run = async () => await fetchFolders();
    run();

    if (folders?.length > 0 && folders[0].folders?.length > 0){
      folders[0].folders.forEach((folder:any)=>{
        if (folder.id===props.folder) setFolderSelected(folder.name);
      })
    }
  }, []);

  useEffect(() => { 
    if (folders && folders.length>0) { 
      if (folders[0].folders.length>0) {
        setAddFolder(false);
        setFoldersList( folders[0].folders.map( (folder:any) => folder.name) );
      }
    }
  }, [folders]);

  const handleChangeName = (e : any) => {
    setValue(e.target.value);
    validateFolderName(e.target.value);
  }

  const validateFolderName = async (value: string) => {
    let valid = false;
    value = value.replace(/  +/g, ' ').trim();

    if (value.toLowerCase()==="all my designs" || value.toLowerCase()==="favorites") setTipLabel("ERROR: This name can not be used");
    else if (value === "")setTipLabel("ERROR: The folder name cannot be an empty value");
    else if (folders?.length > 0 && folders[0].folders?.length > 0) {
        valid = true;

        folders[0].folders.forEach(function (item: any) {
          if (item.name.toLowerCase()===value.toLowerCase()) valid = false;
        });
        
        if (!valid) setTipLabel("ERROR: Two folders connot share the same name");
        else setTipLabel("");
    }
    else{
      setTipLabel("");
      valid = true;
    }
    
    if (props.handleData) props.handleData("folder", { value: value, id:"", valid: valid, change: true, new: true});
  }

  const handleCheckboxChange = (evt:React.ChangeEvent<HTMLInputElement>) => {
    setChecked(evt.currentTarget.checked);
    if (props.handleData) props.handleData("designAdd", { value: evt.currentTarget.checked, valid: true});
  }

  const handleSelectOption = (id:string, val:string) => {
    let idFolder = "";
    folders[0].folders.forEach((folder:any)=>{
      if (folder.name===val) idFolder=folder.id;
    })

    if (value!==val) {
      setFolderSelected(val);
      if (props.handleData) props.handleData("folder", { value: val, id:idFolder, valid: true, change: true, new: false});
    }
  }
  
  let borderColor = "";
  if (tipLabel!=="" && !isChecking) borderColor = `solid 1px ${C.RED}`;
  
  return (
    <S.Root>
      {showLoading && <Loading containerStyle={{justifyContent: 'center'}}/>}

      {!addFolder && !showLoading &&
        <>
          <S.Title>Add to Folder</S.Title>
          <ComboBox 
            id="folder"
            placeholder="Select Folder"
            options={foldersList}
            required={false}
            disabled={false}
            position={"bottom"}
            chooseOption={handleSelectOption}
            value={ folderSelected }
            containerStyle={{width: "50%", display: "inline-block"}}
            style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}
          />
          
          <Button
            label="CREATE NEW FOLDER"
            style={{
              marginLeft: "17px", 
              marginTop: "23px", 
              padding: "16px",
              backgroundColor: "transparent", 
              border: "1px solid transparent", 
              hoverBackgroundColor: "#e1e3e9;",
              display: "inline-block",
              position: "absolute",
              boxShadow: 'unset'
            }}
            labelStyle={{color: C.DARK_BLUE}}
            onClick={() => setAddFolder(true)}
          />
        </>
      }

      {addFolder && !showLoading &&
        <>
          <S.Title>New Folder Title</S.Title>
          <Input 
            id={"template-name"}
            placeholder={"Enter name for folder"}
            value={value}
            handleChange={(event:ChangeEvent<HTMLInputElement>) => handleChangeName(event)}
            disabled={false}
            tipLabel={tipLabel}
            tipLabelColor={isChecking ? '#8891a0' : C.RED}
            style={{
              marginTop: '16px',
            }}
            inputStyle={{
              color: C.BLACK,
              border: borderColor
            }}
          />

          <S.Folders>
            <S.CheckboxContainer className=''>
              <S.HiddenCheckbox checked={checked} onChange={(evt)=>handleCheckboxChange(evt)}/>
              <S.StyledCheckbox checked={checked}>
                <S.Icon viewBox="0 0 24 24">
                  <polyline points="20 6 9 17 4 12" />
                </S.Icon>
              </S.StyledCheckbox>
            </S.CheckboxContainer>
            <S.Label>Add {props.name} to your new folder</S.Label>
          </S.Folders>
        </>
      }

    </S.Root >
  );
}

export default Folders;